export const WINDOW_RESIZE = 'WINDOW_RESIZE';
export const TOGGLE_TRIANGLE = 'TOGGLE_TRIANGLE';
export const TOGGLE_SQUARE = 'TOGGLE_SQUARE';
export const TOGGLE_CIRCLE = 'TOGGLE_CIRCLE';
export const TOGGLE_LOADER = 'TOGGLE_LOADER';
export const TOGGLE_ABOUT = 'TOGGLE_ABOUT';
export const SET_PALETTE = 'SET_PALETTE';



/** WEBPACK FOOTER **
 ** ./src/actions/constants.js
 **/